import {
  getAuth,
} from 'firebase/auth';
import {
  getDatabase,
  ref,
  get,
  update,
  child,
} from 'firebase/database';
import {
  all,
  fork,
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects';
import actions from './actions';
import authActions from '../auth/actions';
import profileActions from '../profile/actions';
import { notification } from '../../components';
import { defaultEtiqueta, defaultFita } from './reducer';

const getIsProfessionalFromStore = (state) => state.Auth.professional;
const getMainUserFromStore = (state) => state.Auth.mainUser;

function getUID(mainUser) {
  if (mainUser) return mainUser;
  const auth = getAuth();
  const { currentUser } = auth;
  return currentUser.uid;
}

function getLabelSettingsFromDB(mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  const uid = getUID(mainUser);
  return get(child(dbRef, `users/${uid}/labelSettings`));
}

// function saveLabelSettingsOnDB(data, mainUser) {
//   const db = getDatabase();
//   const dbRef = ref(db);
//   const uid = getUID(mainUser);
//   const updates = {};
//   updates[`users/${uid}/labelSettings`] = data;
//   return update(dbRef, updates);
// }

function saveActiveProfileOnDB(profile, mainUser) {
  const db = getDatabase();
  const dbRef = ref(db);
  const uid = getUID(mainUser);
  const updates = {};
  updates[`users/${uid}/labelSettings/activeProfile`] = profile;
  return update(dbRef, updates);
}

export function* fetchLabelSettings() {
  yield takeLatest([
    authActions.LOGIN_SUCCESS,
    actions.FETCH_LABEL_SETTINGS_REQUEST,
    profileActions.PROFILE_INFO_SUCCESS,
  ], function* () {
    try {
      const professional = yield select(getIsProfessionalFromStore);
      if (professional) {
        const mainUser = yield select(getMainUserFromStore);
        const snapshot = yield call(getLabelSettingsFromDB, mainUser);
        const raw = snapshot.val() || {};
        yield put({
          type: actions.FETCH_LABEL_SETTINGS_SUCCESS,
          payload: {
            activeProfile: raw.activeProfile || 'etiqueta',
            etiqueta: { ...defaultEtiqueta, ...(raw.etiqueta || {}) },
            fita: { ...defaultFita, ...(raw.fita || {}) },
          },
        });
      }
    } catch (error) {
      console.warn(error);
    }
  });
}

export function* saveLabelSettings() {
  yield takeLatest(actions.SAVE_LABEL_SETTINGS_REQUEST, function* (action) {
    try {
      yield put({ type: actions.SAVING_LABEL_SETTINGS });
      const mainUser = yield select(getMainUserFromStore);
      const { profile, settings } = action.payload;

      const db = getDatabase();
      const dbRef = ref(db);
      const uid = getUID(mainUser);
      const updates = {};
      updates[`users/${uid}/labelSettings/${profile}`] = settings;
      yield call(() => update(dbRef, updates));

      yield put({
        type: actions.SAVE_LABEL_SETTINGS_SUCCESS,
        payload: { profile, settings },
      });
    } catch (error) {
      console.warn(error);
      notification(
        'error',
        'Algo deu errado',
        'Tente novamente mais tarde.',
      );
      yield put({ type: actions.SAVE_LABEL_SETTINGS_ERROR });
    }
  });
}

export function* setActiveProfile() {
  yield takeLatest(actions.SET_ACTIVE_PROFILE, function* (action) {
    try {
      const mainUser = yield select(getMainUserFromStore);
      yield call(saveActiveProfileOnDB, action.payload, mainUser);
    } catch (error) {
      console.warn(error);
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(fetchLabelSettings),
    fork(saveLabelSettings),
    fork(setActiveProfile),
  ]);
}
